import { PropsWithChildren } from 'react';
import PageLayout from './PageLayout';

const MdxLayout: React.FC<PropsWithChildren<any>> = ({ children }) => {
    return (
        <PageLayout className="prose" py="lg" width="sm">
            {children}
        </PageLayout>
    )
}

export default MdxLayout